<template lang="pug">
	.track-action-key
		input.form-control.form-control-sm(type="text" :value="value", v-on:input="Settings.setSettingValue(setting.codename, $event.target.value)")

		button.download-button(v-b-tooltip.hover="{title: 'Download results'}" v-on:click="downloadResults")
			.download-icon
				.fa.fa-download

</template>

<script>

	import Screen 				from './../../../mixins/screen';
	import { Auth } from "../../../services/Auth";

	import { Creative } 			from './../../../services/Creative';
	import { Settings } 		from './../../../services/Settings';
	import SetupSettings 		from "@/settings/settings.json";

	export default {
		name: "TrackRatingKey",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Switched", "Selected Version Fully Loaded"]
		},
		props: ['setting'],
		data() {

			this.value = null;
			this.Settings = Settings;
			this.Creative = Creative;

			return {
				showed: true
			}

		},
		mounted() {

			//Сообщаем компоненту что он должен обновляться при изменении указанных настроек активной версии креатива
			this.addUpdateEvent([`Selected Version Setting Changed:track-rating-key`]);

		},
		methods: {
			collectData() {
				this.value = Settings.getSettingValue(this.setting.codename);
			},

			downloadResults() {

				let creativeId = Creative.SelectedCreative.id;
				let ratingKey = this.value;

				let url = 'http://' + SetupSettings["domain"] + `/stat/downloadRatingScores?creativeId=${creativeId}&ratingKey=${ratingKey}`;
				if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + `/stat/downloadRatingScores?creativeId=${creativeId}&ratingKey=${ratingKey}`;

				let xhr = new XMLHttpRequest();
				xhr.open("GET", url, true);
				Auth.authorizeRequest(xhr);

				xhr.onload = () => {
					if (xhr.readyState === 4 && xhr.status === 200) {
						const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });
						const url = URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.href = url;
						link.download = `${ratingKey}-stats-${creativeId}.csv`;
						link.click();
						URL.revokeObjectURL(url);
					}
				};
				xhr.send();
			},
		}
	}
</script>

<style lang="sass">

	.track-action-key
		display: flex
		flex-direction: row
		justify-content: space-between

		>input
			width: 65%

		>.download-button
			margin-top: 2px
			width: 30%
			border: 1px solid #c8ced3
			border-radius: 0.25rem
			color: #c8ced3
			background-color: #3a4149

			&:hover
				color: #23282c
				background-color: #c8ced3
				border-color: #c8ced3


</style>
